import React, { useState } from "react"
import projects from "../../data/projects.json"
import './Projects.css'

export default function Projects() {
    const [project, selectProject] = useState(null)

    const getDetails = (id) => {
        const found = projects.find((p) => p.id === id)
        if (found) selectProject(found)
    }

    const resetState = () => {
        selectProject(null)
    }

    return (
        <>
            <h2>Jake's Projects</h2>
            <div className="project-map">
                {project ?
                    <div className="project-detail">
                        <h2>{project.title}</h2>
                        <div className="project-sections">
                            <div className="project-left">
                                <img src={project.image} alt={project.title} />
                            </div>
                            <div className="project-right">
                                <div class="project-description">
                                    <p>{project.description}</p>
                                </div>
                                <div className="project-tags">
                                    {project.tags.map((tag) => (
                                        <span key={tag} className="tag">{tag}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="exit-buttons">
                            <p class="detail-btn"><a href={project.url} target="_blank" rel="noopener noreferrer">Check it Out!</a></p>
                            <p class="detail-btn"><a href="#projects" onClick={resetState}>Return to Projects</a></p>
                        </div>
                    </div>
                    :
                    projects.map((project) => (
                        <div key={project.id} className="project-card">
                            <div className="overlay">
                                <button onClick={() => getDetails(project.id)}>View</button>
                            </div>
                            <img src={project.image} alt={project.title} />
                            <p>{project.title}</p>
                        </div>
                    ))
                }
            </div>
        </>
    )
}